export var INSIDER_TRADING = "INSIDER_TRADING";
export var INSIDER_TRADING_ERROR = "INSIDER_TRADING_ERROR";
export var INSIDER_TRADING_HIDE_ERROR = "INSIDER_TRADING_HIDE_ERROR";
export var INSIDER_START_LOADER = "START_LOADER";
export var INSIDER_STOP_LOADER = "INSIDER_STOP_LOADER";
export var INSIDER_SORT = "INSIDER_SORT";
export var INSIDER_CLEAR_SORT = "INSIDER_CLEAR_SORT";
